export default {
  acceptTermsRequired: 'దయచేసి terms and conditions అంగీకరించండి',
  accountNumber: 'A/C Number',
  acknowledgedText: 'అంగీకరించబడింది',
  acknowledgeText: 'అంగీకరించండి',
  active: 'చురుకైన',
  activeBookings: 'చురుకైన బుకింగ్‌లు',
  activeBucketsText: 'యాక్టివ్ బకెట్‌లు',
  activeToday: 'నేడు చురుకైన',
  adminRole: 'అడ్మిన్ — మేనేజింగ్ డైరెక్టర్',
  advance: 'అడ్వాన్స్',
  advancePaid: 'అడ్వాన్స్ చెల్లించబడింది',
  advancePaidLabel: 'అడ్వాన్స్',
  agreement: 'నిబంధనలు & ఒప్పందం',
  agreeTermsCheckbox: 'నేను అన్ని నిబంధనలు & షరతులు చదివి అంగీకరించాను',
  alertLog: 'హెచ్చరిక లాగ్',
  alerts: 'హెచ్చరికలు',
  alertText: 'హెచ్చరిక',
  allAlerts: 'అన్ని హెచ్చరికలు',
  allLoaded: 'అన్నీ లోడ్',
  allMachinesOk: 'అన్ని మెషీన్‌లు సరిగ్గా పని చేస్తున్నాయి.',
  allowedText: 'అనుమతించబడింది',
  allStats: 'పూర్తి గణాంకాలు',
  amount: 'మొత్తం',
  apiHealthTitle: 'API Health',
  apiSloAlertsTitle: 'API SLO Alerts',
  appName: 'డెవలప్‌మెంట్ ఎక్స్‌ప్రెస్',
  approvals: 'ఆమోదాలు',
  approveAndDispatch: 'ఆమోదించి మెషీన్ పంపండి',
  approved: 'ఆమోదించబడింది',
  assignedOperator: 'కేటాయించిన ఆపరేటర్',
  attemptsLabel: 'ప్రయత్నాలు',
  attendance: 'హాజరు',
  auditLogs: 'ఆడిట్ లాగ్‌లు',
  available: 'అందుబాటులో',
  availableMachinery: 'అందుబాటులో ఉన్న మెషినరీ',
  availableNow: 'ఇప్పుడు అందుబాటులో',
  avgRating: 'సగటు రేటింగ్',
  awaitingClientFeedback: 'గ్రాహకుడు ఫీడ్‌బ్యాక్ కోసం వేచి',
  awaitingDispatch: 'డిస్పాచ్ కోసం వేచి',
  back: 'వెనుకకు',
  backToLogin: 'లాగిన్‌కు తిరిగి',
  bank: 'బ్యాంక్',
  bankDetailsTitle: 'బ్యాంక్ వివరాలు',
  baseAmount: 'ప్రాథమిక మొత్తం',
  billingWallet: 'వాలెట్ & బిల్లింగ్',
  blacklistWarning: '⛔ బ్లాక్‌లిస్ట్ హెచ్చరిక',
  blockedRateText: 'బ్లాక్ రేట్',
  blockedText: 'బ్లాక్ చేయబడింది',
  bookingConfirm: 'బుకింగ్ నిర్ధారించండి',
  bookingCostCalculator: 'బుకింగ్ & ఖర్చు కాలిక్యులేటర్',
  bookingFailedGeneric: 'బుకింగ్ విఫలమైంది. మళ్లీ ప్రయత్నించండి.',
  bookingHistory: 'బుకింగ్ చరిత్ర',
  bookingReportTitle: 'బుకింగ్ నివేదిక',
  bookingScheduleSummary: 'రోజు & నెల వారీ బుకింగ్ షెడ్యూల్',
  bookingsCount: '{count} బుకింగ్‌లు',
  bookingSelectMachineFirst: 'కొనసాగడానికి ఫ్లీట్ నుండి మెషీన్ ఎంచుకోండి.',
  bookingsScheduleHint: 'క్లయింట్‌లు బుక్ చేసినప్పుడు రోజువారీ షెడ్యూల్ ఇక్కడ కనిపిస్తుంది.',
  bookingStepChoose: 'మెషీన్ ఎంచుకోండి',
  bookingStepConfirm: 'నిర్ధారించి చెల్లించండి',
  bookingStepCost: 'ఖర్చు & తేదీలు',
  bookingType: 'బుకింగ్ రకం ఎంచుకోండి',
  bookingTypeLabel: 'బుకింగ్ రకం',
  bookingTypeText: 'బుకింగ్ రకం',
  bookMachine: 'మెషీన్ బుక్ చేయండి',
  bookMachineAction: 'మెషీన్ బుక్ చేయండి',
  bookNow: 'ఇప్పుడే బుక్ చేయండి',
  burstText: 'BURST',
  busy: 'బిజీ',
  callNow: 'ఇప్పుడు కాల్ చేయండి',
  cancel: 'రద్దు చేయండి',
  cancelAction: 'రద్దు చేయండి',
  cancelBooking: 'బుకింగ్ రద్దు చేయండి',
  cancelBookingPrompt: 'బుకింగ్ రద్దు చేయాలా?',
  cancelPolicy: 'రద్దు విధానం',
  cancelText: 'రద్దు',
  cancelWarning: 'మీరు రద్దు చేయాలనుకుంటున్నారా?',
  changeLanguage: 'భాషను మార్చండి',
  changeMachine: 'మెషీన్ మార్చండి',
  changeMobileNumber: 'మొబైల్ నంబర్ మార్చండి',
  chipAction: 'చర్య',
  chipActor: 'నటుడు',
  chipEntity: 'entity',
  chipFrom: 'నుండి',
  chipMeta: 'meta',
  chipRole: 'పాత్ర',
  chipTo: 'వరకు',
  clearAll: 'అన్నీ క్లియర్ చేయండి',
  client: 'గ్రాహకుడు',
  clientFeedbackLabel: 'గ్రాహకుడు ఫీడ్‌బ్యాక్',
  clientPortal: 'గ్రాహకుల పోర్టల్',
  clientRatingsTitle: 'గ్రాహకుడు రేటింగ్‌లు & సూచనలు',
  clientRole: 'గ్రాహకుడు (కాంట్రాక్టర్)',
  clients: 'గ్రాహకులు',
  commission: 'కమీషన్',
  commission15: 'కమీషన్ 15%',
  commissionPaid: 'కమీషన్ చెల్లించబడింది',
  commissionRate: 'స్థూల బిల్లింగ్ యొక్క 15%',
  company: 'కంపెనీ',
  companyDetailsTitle: 'కంపెనీ వివరాలు',
  completeBookings: 'పూర్తయిన బుకింగ్‌లు',
  completedBookings: 'పూర్తయిన బుకింగ్‌లు',
  condition: 'స్థితి',
  confirm: 'నిర్ధారించండి',
  confirmBooking: 'బుకింగ్ నిర్ధారించండి',
  confirmBookingAction: 'బుకింగ్ నిర్ధారించండి',
  confirmCancel: 'రద్దు నిర్ధారించండి',
  confirmPassword: 'పాస్‌వర్డ్ నిర్ధారించండి',
  confirmRetry: 'మళ్లీ ప్రయత్నం నిర్ధారించండి',
  contactCompany: 'Development Express ను సంప్రదించండి',
  costCalculator: 'ఖర్చు కాలిక్యులేటర్',
  crawlerNoRto: 'Crawler (RTO లేదు)',
  currentlyDeployed: 'ప్రస్తుతం డిప్లాయ్',
  customAmount: 'కస్టమ్ మొత్తం (కనీసం ₹5,000)',
  cycles: "చక్రాలు",
  dailyWorkReport: 'రోజువారీ పని నివేదిక',
  dashboard: 'డాష్‌బోర్డ్',
  date: 'తేదీ',
  dayMachinesLabel: 'మెషీన్‌లు',
  days: 'రోజులు',
  daysUnit: 'రోజులు',
  directContactBlacklist: 'ప్రత్యక్ష సంపర్కం = బ్లాక్‌లిస్ట్',
  directContactProhibited: 'ప్రత్యక్ష సంప్రదింపులు కఠినంగా నిషేధించబడ్డాయి',
  directContactProhibitedText: 'ప్రత్యక్ష సంప్రదింపు కఠినంగా నిషేధించబడింది',
  dispatched: 'పంపబడింది',
  dlqMonitor: 'DLQ మానిటర్',
  docChassisPlate: 'Chassis / Serial Plate Photo (RTO RC లేదు)',
  docEquipmentPhoto: 'Full Machine Photo (side view)',
  docIdentity: 'PAN Card / Aadhaar',
  docInsurance: 'Insurance Certificate',
  docInsuranceOptional: 'Insurance / Equipment Cover (if available)',
  docMachineInvoice: 'Machine Purchase / Invoice (dealer bill)',
  docPollution: 'Pollution Certificate (PUC)',
  docRcBook: 'RC Book (RTO Registration Certificate)',
  documents: 'పత్రాలు అప్‌లోడ్',
  documentUploadTitle: 'పత్రాలు అప్‌లోడ్',
  download: 'డౌన్లోడ్',
  drawerMenu: 'మెనూ',
  earnings: 'ఆదాయం',
  email: 'ఇమెయిల్ మద్దతు',
  emailAddress: 'ఇమెయిల్ చిరునామా',
  emailAddressLabel: 'ఇమెయిల్ చిరునామా',
  expandBookingHint: 'పూర్తి బుకింగ్, రద్దు మరియు ఆపరేటర్ రేటింగ్ కోసం క్రింద నెల/రోజు విభాగాన్ని విస్తరించండి.',
  experience: 'అనుభవం',
  exportCsv: 'CSV ఎగsport',
  failedText: 'విఫలమైంది',
  feedbackAfterDispatch: 'మెషీన్ డిస్పాచ్ తర్వాత ఆపరేటర్ రేటింగ్ అందుబాటులో ఉంటుంది.',
  feedbackStatusAfterDispatch: 'డిస్పాచ్ తర్వాత',
  feedbackStatusRateNow: 'ఆపరేటర్‌ను రేట్ చేయండి ↓',
  filterAll: 'అన్నీ',
  filterCredit: 'క్రెడిట్',
  filterDebit: 'డెబిట్',
  filterCompleted: 'పూర్తి',
  filterCancelled: 'మూసివేయబడింది',
  filterPending: 'పెండింగ్',
  filterDisputed: 'వివాదం',
  forgotPasswordChooseMethod: 'పాస్‌వర్డ్ రీసెట్ కోసం ఇమెయిల్ లింక్ లేదా SMS OTP ఎంచుకోండి.',
  forgotPasswordEmailDevHint: 'Local dev: API server టర్మినల్ తెరిచి “Password reset link (development)” URL కాపీ చేయండి.',
  forgotPasswordEmailHint: 'నమోదైన అడ్మిన్ ఇమెయిల్ చిరునామా నమోదు చేయండి.',
  forgotPasswordFailed: 'రీసెట్ లింక్ పంపలేకపోయాము. మళ్లీ ప్రయత్నించండి.',
  forgotPasswordIntro: 'నమోదైన ఇమెయిల్ చిరునామాకు సురక్షిత రీసెట్ లింక్ పంపుతాము.',
  forgotPasswordInvalidEmail: 'చెల్లుబాటు అయ్యే ఇమెయిల్ చిరునామా నమోదు చేయండి.',
  forgotPasswordInvalidOtp: 'SMS నుండి 6 అంకెల OTP నమోదు చేయండి.',
  forgotPasswordInvalidPhone: 'చెల్లుబాటు అయ్యే 10 అంకెల మొబైల్ నంబర్ నమోదు చేయండి.',
  forgotPasswordLink: 'పాస్‌వర్డ్ మర్చిపోయారా?',
  forgotPasswordOtpSentTo: 'OTP పంపబడింది:',
  forgotPasswordPhoneHint: 'నమోదైన మొబైల్ నంబర్ నమోదు చేయండి. రీసెట్ లింక్ మీ ఖాతాలోని ఇమెయిల్‌కు వెళ్తుంది.',
  forgotPasswordSending: 'పంపుతోంది...',
  forgotPasswordSendingOtp: 'OTP పంపుతోంది...',
  forgotPasswordSendOtp: 'OTP పంపండి',
  forgotPasswordSmsDevHint: 'Productionలో SMS ఇంకా సెట్ కాలేదు — developmentలో OTP కోడ్ కోసం server logs చూడండి.',
  forgotPasswordSmsFailed: 'OTP పంపలేకపోయాము. మళ్లీ ప్రయత్నించండి.',
  forgotPasswordSmsHint: 'నమోదైన మొబైల్ నంబర్ నమోదు చేయండి. 6 అంకెల OTP SMS ద్వారా పంపబడుతుంది.',
  forgotPasswordSmsSuccess: 'ఖాతా ఉంటే, నమోదైన మొబైల్‌కు OTP పంపబడింది.',
  forgotPasswordSubmit: 'రీసెట్ లింక్ పంపండి',
  forgotPasswordSuccess: 'ఖాతా ఉంటే, నమోదైన ఇమెయిల్‌కు రీసెట్ సూచనలు పంపబడ్డాయి.',
  forgotPasswordTitle: 'మీ పాస్‌వర్డ్ రీసెట్ చేయండి',
  formLabel: 'ఫారం',
  fuel: 'ఇంధనం',
  fuelColon: 'ఇంధనం:',
  fuelHistoryTitle: 'ఇంధన చరిత్ర',
  fuelLevel: 'ఇంధన స్థాయి',
  fuelLevelUpdate: 'ఇంధన స్థాయి అప్‌డేట్',
  fuelNotePlaceholder: 'గమనిక: నింపిన / ఉపయోగించిన ఇంధనం...',
  fullName: 'పూర్తి పేరు',
  goBook: '→ మెషీన్ బుక్ చేయండి',
  gpsLiveLabel: '🟢 GPS లైవ్',
  grandTotal: 'మొత్తం మొత్తం',
  grandTotalText: 'మొత్తం మొత్తం',
  gross: 'స్థూల',
  grossBilling: 'స్థూల బిల్లింగ్',
  gst18: 'GST (18%)',
  gstin: 'GSTIN',
  gstInvoice: 'GST ఇన్వాయిస్',
  gstInvoices: 'GST ఇన్వాయిస్‌లు',
  hide: 'దాచు',
  highTrend: 'HIGH Trend',
  hitsText: 'hits',
  hmrHrs: 'గం',
  hmrToday: 'నేటి HMR',
  hmrTotal: 'మొత్తం HMR',
  home: 'హోమ్',
  hours: 'గంటలు',
  hrsUnit: 'గంటలు',
  idle: 'నిష్క్రియ',
  ifsc: 'IFSC',
  ignition: 'ఇగ్నిషన్',
  importantInfo: 'మెషీన్ యజమానులకు ముఖ్యమైన సమాచారం',
  instantCost: 'తక్షణ ఖర్చు కాలిక్యులేటర్',
  invoiceNotAvailableCancelled: 'ఇన్వాయిస్ అందుబాటులో లేదు (రద్దు)',
  iot: 'IoT & GPS',
  issueReportedSuccess: 'సమస్య విజయవంతంగా నివేదించబడింది!',
  issueReportTitle: 'సమస్య నివేదిక',
  issues: 'సమస్యలు',
  joinUsAction: 'Join Us — ఉచిత నమోదు',
  joinUsBanner: 'మెషినరీ అద్దెకు కావాలా?',
  joinUsHint: 'కొత్త గ్రాహకుడు? JCB, excavator, crane బుక్ చేయడానికి ఉచితంగా నమోదు చేయండి.',
  landingCtaApp: 'Development Express అన్వేషించండి',
  landingFeatBook: 'నిమిషాల్లో బుకింగ్',
  landingFeatBookDesc: 'JCB, excavators, cranes — live availability & instant booking.',
  landingFeatPay: 'Wallet-only payments',
  landingFeatPayDesc: 'పారదర్శక బిల్లింగ్, GST invoices, నగదు గందరగోళం లేదు.',
  landingFeatTrack: 'Live GPS tracking',
  landingFeatTrackDesc: 'అద్దె ప్రతి గంట మీ మెషీన్ ఎక్కడ ఉందో తెలుసుకోండి.',
  landingHeroLine1: 'Smarter & Simpler.',
  landingHeroLine2: 'మహారాష్ట్ర మెషినరీ అద్దె — కొత్త రీతి.',
  landingSocialProof: 'మహారాష్ట్ర అంతటా బిల్డర్‌లు, కాంట్రాక్టర్‌లు & ఫ్లీట్ యజమానులు.',
  landingStatMachines: 'మెషీన్‌లు',
  landingStatRating: 'రేటింగ్',
  landingTrustLine: 'Wallet-only · GST compliant · Secured operations',
  lastRefreshed: 'చివరి రిఫ్రెష్',
  live: 'లైవ్',
  liveBookAvail: 'బుకింగ్ తర్వాత లైవ్ ఫీడ్ అందుబాటులో',
  liveCamera: '360° లైవ్ కెమెరా — బుకింగ్ తర్వాత',
  liveMachineLocation: 'లైవ్ మెషీన్ స్థానం',
  liveText: 'లైవ్',
  liveTracking: 'లైవ్ ట్రాకింగ్',
  loadedBookings: 'లోడ్ చేసిన బుకింగ్‌లు',
  loadedDlqItems: 'లోడ్ చేసిన DLQ అంశాలు',
  loadedFuelLogs: 'లోడ్ చేసిన ఇంధన లాగ్‌లు',
  loadedOwnerBookings: '{count} యజమాని బుకింగ్‌లు లోడ్{suffix}',
  loading: 'లోడ్ అవుతోంది...',
  loadingDashboard: 'డాష్‌బోర్డ్ లోడ్ అవుతోంది...',
  loadMoreAlerts: 'మరిన్ని హెచ్చరికలు లోడ్ చేయండి',
  loadMoreAttendance: 'మరిన్ని హాజరు లోడ్ చేయండి',
  loadMoreBookings: 'మరిన్ని బుకింగ్‌లు లోడ్ చేయండి',
  loadMoreDlq: 'మరిన్ని DLQ లోడ్ చేయండి',
  loadMoreFuelLogs: 'మరిన్ని ఇంధన లాగ్‌లు లోడ్ చేయండి',
  loadMoreLogs: 'మరిన్ని లాగ్‌లు లోడ్ చేయండి',
  loadMoreMachines: 'మరిన్ని మెషీన్‌లు లోడ్ చేయండి',
  loadMoreTransactions: 'మరిన్ని లావాదేవీలు లోడ్ చేయండి',
  loadMoreUsers: 'మరిన్ని వినియోగదారులు లోడ్ చేయండి',
  location: 'స్థానం',
  lockConfirm: '🔒 లాక్ నిర్ధారించండి',
  locked: 'లాక్ చేయబడింది',
  lockMachine: 'మెషీన్ లాక్ చేయండి',
  lockWarning: 'Teltonika GPS ద్వారా మెషీన్ ఇగ్నిషన్ దూరంగా నిలిపివేయబడుతుంది.',
  loginAs: 'లాగిన్ అవుతున్నారు',
  loginChangeRole: 'పాత్ర మార్చండి',
  loginClientPortalSubtitle: 'నిర్మాణ మెషినరీ బుక్ చేయడానికి సైన్ ఇన్',
  loginEmailHint: 'అడ్మిన్ లాగిన్ కోసం నమోదైన ఇమెయిల్ ఉపయోగించండి.',
  loginFailedGeneric: 'లాగిన్ విఫలమైంది — దయచేసి మళ్లీ ప్రయత్నించండి',
  loginIAmQuestion: 'నేను ఎవరు…?',
  loginModeOtp: 'OTP లాగిన్',
  loginModePassword: 'పాస్‌వర్డ్',
  loginNewHereRegister: 'కొత్తవారా? నమోదు',
  loginOtpDevHint: 'Development: SMS లేకపోతే API server log లో OTP చూడండి.',
  loginOtpHint: 'మీ నమోదైన మొబైల్ నంబర్‌కు 6 అంకెల OTP పంపబడుతుంది.',
  loginOtpSentTo: 'OTP పంపబడింది:',
  loginOwnerPortalSubtitle: 'ఫ్లీట్ & నమోదు నిర్వహించడానికి సైన్ ఇన్',
  loginPhoneHint: 'గ్రాహకుడు, యజమాని మరియు ఆపరేటర్ లాగిన్ కోసం నమోదైన మొబైల్ నంబర్ ఉపయోగించండి.',
  loginPickRoleHint: 'నమోదైనవారా? పాత్ర ఎంచుకోండి. కొత్తవారా? క్రింద Join Us.',
  loginPortalAdminSubtitle: 'ప్లాట్‌ఫారమ్ నియంత్రణ & ఆమోదాలు',
  loginPortalAdminTitle: 'అడ్మిన్ పోర్టల్',
  loginPortalClientSubtitle: 'నిర్మాణ మెషినరీ బుక్ చేయడానికి సైన్ ఇన్',
  loginPortalClientTitle: 'గ్రాహకుడు పోర్టల్',
  loginPortalOperatorSubtitle: 'కేటాయించిన మెషీన్‌లు & లాగ్‌ల కోసం సైన్ ఇన్',
  loginPortalOperatorTitle: 'ఆపరేటర్ పోర్టల్',
  loginPortalOwnerSubtitle: 'ఫ్లీట్ & నమోదు నిర్వహించడానికి సైన్ ఇన్',
  loginPortalOwnerTitle: 'యజమాని పోర్టల్',
  loginRoleAdminDesc: 'ప్లాట్‌ఫారమ్ నియంత్రణ, ఆమోదాలు & ఆపరేషన్స్',
  loginRoleClientDesc: 'నిర్మాణ ప్రాజెక్ట్‌లకు మెషినరీ బుక్ చేయండి',
  loginRoleClientShort: 'గ్రాహకుడు',
  loginRoleOperatorDesc: 'కేటాయించిన మెషీన్‌లు & రోజువారీ లాగ్‌లు',
  loginRoleOwnerDesc: 'ఫ్లీట్, ఆదాయం & లభ్యత నిర్వహించండి',
  loginRoleOwnerShort: 'యజమాని',
  loginSendingOtp: 'OTP పంపుతోంది...',
  loginSendOtp: 'OTP పంపండి',
  loginSignInShort: 'సైన్ ఇన్',
  loginTabOtp: 'OTP',
  loginTabPassword: 'పాస్‌వర్డ్',
  loginVerifyingOtp: 'Verify అవుతోంది...',
  loginVerifyOtp: 'Verify & Sign In',
  logout: 'లాగ్అవుట్',
  sessionRevokedAlert: 'మీరు మరో పరికరంలో లాగిన్ అయ్యారు. దయచేసి మళ్లీ లాగిన్ చేయండి.',
  machine: 'మెషీన్',
  machineDefaultLabel: 'మెషీన్',
  machineDetails: 'మెషీన్ & ఆపరేటర్ వివరాలు',
  machineDetailsTitle: 'మెషీన్ వివరాలు',
  machineDispatchedAt: 'మెషీన్ పంపబడింది — {when}',
  machineHours: 'మెషీన్ గంటలు',
  machineIdLabel: 'మెషీన్ ID',
  machineInfo: 'మెషీన్ సమాచారం',
  machineLabel: 'మెషీన్',
  machineLog: 'మెషీన్ లాగ్',
  machineReg: 'మెషీన్ నమోదు ఫారం',
  machineRegistrationSubmitted: 'మెషీన్ నమోదు సమర్పించబడింది! DE బృందం 24 గంటల్లో ధృవీకరిస్తుంది.',
  machineRegistrationTitle: 'మెషీన్ నమోదు',
  machines: 'మెషీన్‌లు',
  machineStatus: 'మెషీన్ స్థితి',
  machineStatusTitle: 'మెషీన్ స్థితి',
  marketingBackHome: 'వెబ్‌సైట్‌కు తిరిగి',
  marketingBadge: 'LIVE OPERATIONS · KARAD, SATARA',
  marketingBuiltFor: 'ఖచ్చితత్వం, అనుపాలన మరియు వేగం కావాల్సిన భారతీయ నిర్మాణ బృందాల కోసం.',
  marketingCtaBook: 'మెషీన్ బుక్ చేయండి',
  marketingCtaLogin: 'Development Express తెరవండి — Login',
  marketingCtaWhatsApp: 'WhatsApp చేయండి',
  marketingFooterRights: '2026 Development Express · Karad, Satara · All rights reserved',
  marketingHeadline: 'మహారాష్ట్రದ leading machinery rental platform',
  marketingLead: 'Real-time GPS tracking, digital wallet payments, and automated operations for construction machinery. Serving Maharashtra since 2011.',
  marketingNavContact: 'సంప్రదింపు',
  marketingNavLogin: 'ప్లాట్‌ఫామ్ లాగిన్ →',
  marketingNavServices: 'సేవలు',
  marketingNavTech: 'Technology',
  marketingServicesTitle: 'మేము ఏమి అందిస్తాము',
  marketingStatDigital: 'Digital payments',
  marketingStatFleet: 'Live machines',
  marketingStatYears: 'సంవత్సరాల అనుభవం',
  marketingSvcOps: 'Full operations stack',
  marketingSvcOpsSub: 'Owner, operator, and client — one platform.',
  marketingSvcPay: 'Wallet-only settlements',
  marketingSvcPaySub: 'GST-ready invoicing — no cash on site.',
  marketingSvcTrack: 'GPS & live status',
  marketingSvcTrackSub: 'Teltonika-linked fleet visibility for every booking.',
  marketingTechLead: 'Development Express ties bookings, compliance, and field telemetry into a single hardened workflow — from first enquiry to final invoice.',
  md: 'MD',
  mediumTrend: 'MEDIUM Trend',
  minAdvanceRequired: 'కనీస అడ్వాన్స్ అవసరం',
  minimumAdvance: 'కనీస అడ్వాన్స్ అవసరం',
  minimumRecharge: 'UPI/కార్డ్ కనీసం ₹1',
  mobileNumber: 'మొబైల్ నంబర్',
  monthMachineSummary: 'ఈ నెల మెషీన్‌లు',
  months: 'నెలలు',
  monthTotalLabel: 'నెల మొత్తం',
  moreAvailable: 'మరింత అందుబాటులో',
  moUnit: 'నెలలు',
  myBookings: 'నా బుకింగ్‌లు',
  myClientRating: 'నా గ్రాహకుడు రేటింగ్',
  myMachines: 'నా మెషీన్‌లు',
  neftRtgs: 'NEFT/RTGS',
  netEarnedMonth: 'నికర ఆదాయం (నెల)',
  netPaid: 'నికర చెల్లింపు',
  netPayable: 'నికర చెల్లించవలసిన',
  netReceived: 'నికర అందుకున్న',
  netReceivedCaps: 'నికర అందుకున్న',
  neverText: 'ఎప్పుడూ లేదు',
  newBooking: 'కొత్త బుకింగ్',
  newClientRegister: 'కొత్త గ్రాహకుడు? ఇక్కడ నమోదు చేయండి',
  newClientRegistration: 'కొత్త గ్రాహకుడు నమోదు',
  newPassword: 'కొత్త పాస్‌వర్డ్',
  nextText: 'తదుపరి',
  noAlerts: 'హెచ్చరికలు లేవు!',
  noAlertsNow: 'ప్రస్తుతం అలర్ట్‌లు లేవు.',
  noBankRefund: '❌ బ్యాంక్ రీఫండ్ లేదు — వాలెట్ క్రెడిట్ మాత్రమే',
  noBookings: 'చురుకైన బుకింగ్‌లు లేవు',
  noBookingsAccount: 'ఈ ఖాతాకు ఇంకా బుకింగ్‌లు లేవు.',
  noBookingsYet: 'ఇంకా బుకింగ్‌లు లేవు',
  noClientFeedbackYet: 'ఇంకా గ్రాహకుడు రేటింగ్‌లు లేవు. డిస్పాచ్ తర్వాత గ్రాహకుడు ఫీడ్‌బ్యాక్ ఇక్కడ కనిపిస్తుంది.',
  noDlqItems: 'DLQ అంశాలు లేవు',
  noFileSelected: 'ఫైల్ ఎంచుకోలేదు',
  noMachinesDashboard: 'ఇంకా మెషీన్‌లు లేవు. మీ ఫ్లీట్‌ను జోడించడానికి మెషీన్ నమోదు ఉపయోగించండి.',
  noMachinesTrack: 'ట్రాక్ చేయడానికి మెషీన్‌లు లేవు',
  noMachinesTrackHint: 'GPS ట్రాకింగ్ కోసం మెషీన్ నమోదు చేయండి.',
  noMachinesYet: 'ఇంకా మెషీన్‌లు నమోదు కాలేదు',
  noMoreAuditLogs: 'ప్రస్తుత ఫిల్టర్‌ల కోసం మరిన్ని ఆడిట్ లాగ్‌లు లేవు.',
  noRecentApiSloBreach: 'ఇటీవల API SLO breach సంకేతాలు లేవు.',
  noRecentFailedLogins: 'ఇటీవల విఫలమైన లాగిన్ ప్రయత్నాలు లేవు.',
  noRefund: 'రీఫండ్ లేదు విధానం',
  normalText: 'సాధారణ',
  noSecuritySignalsFound: 'భద్రతా సంకేతాలు కనుగొనబడలేదు.',
  noTransactionsFilter: 'ఎంచుకున్న ఫిల్టర్‌కు లావాదేవీలు లేవు.',
  off: 'OFF',
  officeLabel: 'ఆఫీస్',
  on: 'ON',
  operator: 'ఆపరేటర్',
  operatorFeedbackColumn: 'ఆపరేటర్ ఫీడ్‌బ్యాక్',
  operatorFeedbackSaved: 'ధన్యవాదాలు! మీ ఫీడ్‌బ్యాక్ సేవ్ అయింది.',
  operatorFeedbackSubmitted: 'మీ ఫీడ్‌బ్యాక్',
  operatorFeedbackTitle: 'ఆపరేటర్ ఫీడ్‌బ్యాక్',
  operatorPortal: 'ఆపరేటర్ పోర్టల్',
  operatorRole: 'ఆపరేటర్',
  operators: 'ఆపరేటర్‌లు',
  operatorSatisfactionQuestion: 'మీరు ఆపరేటర్‌తో సంతృప్తిగా ఉన్నారా?',
  operatorSuggestionPlaceholder: 'సూచన లేదా ఫీడ్‌బ్యాక్ (ఐచ్ఛికం)',
  optionalLabel: '(ఐచ్ఛికం)',
  otpCode: 'OTP కోడ్',
  overview: 'అవలోకనం',
  ownerBookingsAllLoaded: ' (అన్నీ లోడ్)',
  ownerBookingsMoreAvailable: ' (మరిన్ని అందుబాటులో)',
  ownerInfo: 'యజమాని సమాచారం',
  ownerPortal: 'యజమాని పోర్టల్',
  ownerRole: 'మెషీన్ యజమాని',
  owners: 'యజమానులు',
  password: 'పాస్‌వర్డ్',
  passwordsMustMatch: 'పాస్‌వర్డ్ మరియు నిర్ధారణ ఒకేలా ఉండాలి.',
  pastIssuesTitle: 'గత సమస్యలు',
  paymentBreakdownTitle: 'చెల్లింపు వివరాలు — April 2026',
  paymentCycle: 'చెల్లింపు చక్రం',
  paymentFailed: 'చెల్లింపు విఫలమైంది! దయచేసి మళ్లీ ప్రయత్నించండి.',
  paymentHistory: 'చెల్లింపు చరిత్ర',
  paymentHistoryTitle: 'చెల్లింపు చరిత్ర',
  paymentMethods: 'చెల్లింపు పద్ధతులు',
  paymentMode: 'చెల్లింపు విధానం',
  paymentSuccess: 'చెల్లింపు విజయవంతం!',
  payNow: 'ఇప్పుడు చెల్లించండి',
  payNowText: 'ఇప్పుడు చెల్లించండి',
  pdfInvoiceFailed: 'ఇన్వాయిస్ PDF సృష్టించలేకపోయాము. మళ్లీ ప్రయత్నించండి.',
  pdfReportFailed: 'రిపోర్ట్ PDF సృష్టించలేకపోయాము. మళ్లీ ప్రయత్నించండి.',
  pdiCompleted: '✅ PDI / Safety inspection పూర్తయింది',
  pdiCrawlerHint: 'Crawler plant: pollution (PUC) అవసరం లేదు — మెషీన్ RTO రోడ్-registered కాదు.',
  pdiInfo: 'PDI తనిఖీ',
  pdiInsuranceApplicable: '✅ Insurance / cover (if applicable)',
  pdiInsuranceValid: '✅ Insurance valid & up to date',
  pdiPollutionValid: '✅ Pollution certificate (PUC) valid',
  pdiTitle: 'Pre-Delivery Inspection (PDI)',
  penaltyDeduct: 'రద్దు జరిమానా (1 గంట)',
  pending: 'పెండింగ్',
  pendingApproval: 'ఆమోదం పెండింగ్',
  pendingCount: '{count} పెండింగ్',
  pendingDispatch: 'డిస్పాచ్ పెండింగ్',
  perDay: 'రోజుకు',
  perHour: 'గంటకు',
  perMonth: 'నెలకు',
  perWeek: 'వారానికి',
  phone: 'ఫోన్',
  platform: 'నిర్మాణ నిర్వహణ వేదిక',
  platformAgreement: 'ప్లాట్‌ఫామ్ ఒప్పందం',
  policyLabel: 'విధానం',
  policyTopicBooking: 'బుకింగ్',
  policyTopicCancellation: 'రద్దు',
  policyTopicContact: 'సంపర్కం',
  policyTopicGst: 'GST',
  policyTopicHours: 'సపోర్ట్ సమయం',
  portalBackLink: 'పోర్టల్',
  portalClient: 'గ్రాహకుడు',
  portalClientSub: 'మెషినరీ బుక్ చేయండి',
  portalNewClientRegister: 'కొత్త గ్రాహకుడు? నమోదు',
  portalNewOwnerRegister: 'కొత్త యజమాని? నమోదు',
  portalOwner: 'యజమాని',
  portalOwnerSub: 'ఫ్లీట్ నిర్వహణ',
  portalStaffAdmin: 'అడ్మిన్',
  portalStaffOperator: 'ఆపరేటర్',
  portalWelcome: 'స్వాగతం',
  portalWelcomeHint: 'కొనసాగడానికి మీ పోర్టల్ ఎంచుకోండి',
  quantityLabel: 'పరిమాణం',
  quickIssueReport: 'త్వరిత సమస్య నివేదిక',
  quickRechargeUpi: 'UPI ద్వారా త్వరిత రీఛార్జ్',
  quickSelect: 'త్వరిత ఎంపిక:',
  rateCard: 'రేట్ కార్డ్ (ఆపరేటర్ సహా)',
  rateLimitTelemetryTitle: 'Rate Limit Telemetry',
  rateOperatorWork: 'ఆపరేటర్ పనిని రేట్ చేయండి (1–5 stars)',
  rating: 'రేటింగ్',
  receiptId: 'రసీదు ID',
  recentAlerts: 'ఇటీవలి హెచ్చరికలు',
  recentFailedLoginsTitle: 'ఇటీవల విఫలమైన లాగిన్‌లు',
  recentLabel: 'ఇటీవలి',
  recharge: 'రీఛార్జ్',
  rechargeFirst: '⚡ ముందు వాలెట్ రీఛార్జ్ చేయండి',
  rechargeWallet: '+ వాలెట్ రీఛార్జ్',
  ref: 'రెఫరెన్స్ నంబర్',
  refreshingText: 'రిఫ్రెష్ అవుతోంది...',
  refreshText: 'రిఫ్రెష్',
  regCapacitySpecs: 'సామర్థ్యం / వివరాలు',
  regDocCrawlerHint: 'Crawler (excavator): chassis plate, machine purchase invoice, machine photo మరియు ID అవసరం. Insurance optional.',
  regDocWheeledHint: 'Wheeled: RC (RTO), insurance, PUC మరియు ID అవసరం (ప్రతి 5MB).',
  regEquipmentCategory: 'పరికర వర్గం *',
  regFailed: 'నమోదు విఫలమైంది. దయచేసి మళ్లీ ప్రయత్నించండి.',
  regFileSizeError: 'ప్రతి document 5MB లేదా తక్కువగా ఉండాలి',
  regFileTypeError: 'PDF, JPG, PNG లేదా WEBP ఫైళ్లు మాత్రమే అనుమతించబడతాయి',
  regFleetIdOptional: 'ఫ్లీట్ / chassis ID (ఐచ్ఛికం)',
  register: 'మెషీన్ నమోదు',
  registerAction: 'నమోదు చేయండి',
  registering: 'నమోదు అవుతోంది...',
  registerMachine: 'మెషీన్ నమోదు',
  registrationPending: 'అడ్మిన్ 24 గంటల్లో మీ అకౌంట్‌ను సక్రియం చేస్తారు.',
  registrationSuccess: 'నమోదు విజయవంతం!',
  regMachineCategory: 'మెషీన్ వర్గం *',
  regMachineInfoTitle: 'మెషీన్ సమాచారం',
  regMachineIntro: 'నిర్మాణ heavy equipment మాత్రమే — ట్రక్/ట్రాన్స్‌పోర్ట్ లేదు. Wheeled plant (ఉదా. JCB 3DX) కు RTO; crawler plant (Poclain, dozer) సైట్-మాత్రమే — RTO passing లేదు.',
  regMachineNameModel: 'మెషీన్ పేరు / మోడల్',
  regMobilityTracked: 'Crawler',
  regMobilityTrackedHint: 'Poclain / chain excavator, dozer, crawler crane — సైట్ plant, RTO passing లేదు',
  regMobilityWheeled: 'Wheeled',
  regMobilityWheeledHint: 'JCB 3DX, wheeled loader, grader — RTO (RC) ఉన్న నిర్మాణ plant',
  machineFinancialSection: 'మెషీన్ కొనుగోలు వివరాలు (ఐచ్ఛికం)',
  machineOwnershipType: 'యాజమాన్య రకం',
  machineOwnershipNew: 'కొత్త మెషీన్',
  machineOwnershipUsed: 'అసలు యజమాని',
  machineOwnershipSecondHand: 'పూర్వ-యాజమాన్యం',
  machinePurchasePrice: 'కొనుగోలు ధర (₹)',
  machinePurchasePriceHint: 'ఈ మెషీన్ కోసం మీరు చెల్లించిన మొత్తం',
  machinePurchaseDate: 'కొనుగోలు తేదీ',
  machineYearOfManufacture: 'తయారీ సంవత్సరం',
  machineLoanSection: 'ఈ మెషీన్‌పై నాకు loan ఉంది',
  machineLoanAmount: 'Loan మొత్తం (₹)',
  machineLoanEmi: 'నెల EMI (₹)',
  machineLoanTenure: 'Loan కాలం (నెలలు)',
  machineLoanStartDate: 'Loan ప్రారంభ తేదీ',
  machineFuelConsumption: 'ఇంధన వినియోగం (L/hr)',
  machineMonthlyOperatingExpenses: 'నెలసరి ఆపరేటింగ్ ఖర్చులు',
  machineOperatorMonthlySalary: 'ఆపరేటర్ నెలసరి జీతం',
  machineServiceMonthly: 'సర్వీసు / నిర్వహణ (నెలసరి)',
  machineBreakdownMonthly: 'బ్రేక్‌డౌన్ / మరమ్మత్తు (నెలసరి సగటు)',
  machineMaterialsMonthly: 'సామగ్రి / వినియోగ వస్తువులు (నెలసరి)',
  recoveryPlan: 'రికవరీ ప్లాన్',
  recoveryOnTrack: 'సరైన మార్గంలో',
  recoveryNeedsAttention: 'శ్రద్ధ అవసరం',
  recoveryActionRequired: 'చర్య అవసరం',
  recoveryAddPrice: 'రికవరీ ప్లాన్ చూడడానికి కొనుగోలు ధర జోడించండి',
  recoveryProgress: 'పెట్టుబడి వసూలు',
  recoveryDailyNet: 'రోజువారీ నికర ఆదాయం',
  recoveryDays: 'రికవరీ వ్యవధి',
  recoveryProjectedDate: 'అంచనా రికవరీ తేదీ',
  recoveryRoi: 'వార్షిక రాబడి',
  recoveryCurrentValue: 'ప్రస్తుత యంత్ర విలువ',
  editFinancialDetails: 'ఆర్థిక వివరాలు సవరించండి',
  financialDetailsSaved: 'ఆర్థిక వివరాలు సేవ్ అయ్యాయి',
  recoveryBackfillNudge: 'రికవరీ ట్రాకింగ్ అన్‌లాక్ చేయడానికి {{count}} మెషిన్(ల)కు కొనుగోలు వివరాలు జోడించండి',
  dieselPriceTitle: 'డీజిల్ ధర',
  dieselPriceUpdate: 'డీజిల్ ధర అప్‌డేట్ చేయండి',
  dieselPriceLatest: 'తాజా ధర',
  dieselPriceNoRecord: 'డీజిల్ ధర నమోదు చేయలేదు',
  dieselPricePerLitre: 'లీటరు ధర (₹)',
  dieselQuantity: 'నింపిన పరిమాణం (లీటర్లు)',
  dieselTaluka: 'నగరం / ప్రాంతం',
  bookingAttachment: 'అటాచ్‌మెంట్ ఎంచుకోండి',
  bookingAttachmentNone: 'నిర్దిష్ట అటాచ్‌మెంట్ లేదు',
  bookingWorkDescription: 'పని వివరణ',
  bookingWorkDescriptionPlaceholder: 'ఉదా. పునాది తవ్వకం, ట్రెంచింగ్, పైప్‌లైన్ పని',
  bookingAttachmentLabel: 'అటాచ్‌మెంట్',
  bookingSiteLabel: 'సైట్',
  bookingWorkLabel: 'పని',
  termsAccept: "నేను నిబంధనలు & షరతులను అంగీకరిస్తున్నాను",
  termsRequired: "నమోదు కోసం నిబంధనలు & షరతులను అంగీకరించాలి",
  termsLink: "నిబంధనలు & షరతులు",
  clientBlacklisted: "బ్లాక్‌లిస్ట్",
  clientBlacklistReason: "బ్లాక్‌లిస్ట్ కారణం",
  clientBlacklistConfirm: "ఈ క్లయింట్‌ను బ్లాక్‌లిస్ట్ చేయాలా?",
  clientUnblacklist: "బ్లాక్‌లిస్ట్ నుండి తీసివేయి",
  blacklistedClients: "బ్లాక్‌లిస్ట్ క్లయింట్లు",
  blacklistedClientsEmpty: "బ్లాక్‌లిస్ట్ క్లయింట్లు లేరు",
  managerAccessRestricted: "ఫైనాన్స్ ప్రాప్తి నియంత్రించబడింది. ఓమ్ చవాన్‌ను సంప్రదించండి.",
  managerSection: "మేనేజర్లు",
  managerAdd: "మేనేజర్ జోడించండి",
  managerName: "మేనేజర్ పేరు",
  managerEmail: "మేనేజర్ ఇమెయిల్",
  managerPassword: "తాత్కాలిక పాస్‌వర్డ్",
  managerCreated: "మేనేజర్ ఖాతా సృష్టించబడింది",
  managerCredentialsTitle: "మేనేజర్ లాగిన్ వివరాలు",
  managerCredentialsSubtitle: "ఈ వివరాలను ఇప్పుడే సేవ్ చేయండి — పాస్‌వర్డ్ తర్వాత తిరిగి రాదు",
  managerCredentialsSaved: "నేను వివరాలను సేవ్ చేశాను",
  managerLoginUrl: "లాగిన్ URL",
  managerActivity: "మేనేజర్ కార్యకలాపం",
  managerActivityEmpty: "ఇంకా ఎలాంటి కార్యకలాపం నమోదు కాలేదు",
  managerActivityViewAll: "మొత్తం కార్యకలాపం చూడండి",
  onboardingTitle: "ప్రారంభించండి",
  onboardingAccountApproved: "ఖాతా ఆమోదించబడింది",
  onboardingKycComplete: "KYC ధృవీకరణ పూర్తి",
  onboardingKycPending: "KYC ధృవీకరణ పూర్తి చేయండి",
  onboardingKycRejected: "KYC తిరస్కరించబడింది — మళ్లీ సమర్పించండి",
  onboardingWalletFunded: "వాలెట్‌లో బ్యాలెన్స్ ఉంది",
  onboardingWalletEmpty: "బుకింగ్ కోసం వాలెట్ బ్యాలెన్స్ జోడించండి",
  pushEnablePrompt: "తక్షణ అప్‌డేట్‌ల కోసం పుష్ నోటిఫికేషన్లను ఆన్ చేయండి",
  downloadDisputeStatement: "వివాద ప్రకటన డౌన్‌లోడ్ చేయండి",
  downloadInvoice: "ఇన్‌వాయిస్ డౌన్‌లోడ్ చేయండి",
  bookAgain: "మళ్లీ బుక్ చేయండి",
  machineNoLongerAvailable: "యంత్రం ఇప్పుడు అందుబాటులో లేదు",
  downloadHistoryPdf: "చరిత్ర PDF డౌన్‌లోడ్ చేయండి",
  onboardingFirstBooking: "మీ మొదటి బుకింగ్ చేయండి",
  onboardingAllDone: "మీరు సిద్ధంగా ఉన్నారు!",
  onboardingTrackerTitle: "ఆన్‌బోర్డింగ్ పురోగతి",
  onboardingTrackerTarget: "ఆన్‌బోర్డింగ్ లక్ష్యం: 48 గంటలు",
  onboardingTrackerInProgress: "పురోగతిలో",
  onboardingTrackerActionRequired: "చర్య అవసరం",
  onboardingTrackerComplete: "పూర్తి",
  onboardingTrackerPending: "పెండింగ్",
  onboardingTrackerPhase1: "నమోదు",
  onboardingTrackerPhase2: "KYC ధృవీకరణ",
  onboardingTrackerPhase3: "యంత్ర నమోదు",
  onboardingTrackerPhase4: "మొదటి బుకింగ్ సిద్ధం",
  onboardingTrackerHelper1: "యంత్ర నమోదు తెరవడానికి ఆధార్ + సెల్ఫీ అప్‌లోడ్ చేయండి",
  onboardingTrackerHelper2: "KYC సమీక్షలో — సాధారణంగా 24 గంటల్లో",
  onboardingTrackerHelper3: "KYC తిరస్కరించబడింది — పత్రాలను మళ్లీ సమర్పించండి",
  onboardingTrackerHelper4: "KYC ఆమోదం — మీ మొదటి యంత్రాన్ని జోడించండి",
  onboardingTrackerHelper5: "యంత్రం అడ్మిన్ సమీక్షలో",
  onboardingTrackerHelper6: "యంత్రం లైవ్ — మొదటి బుకింగ్ కోసం వేచి",
  onboardingTrackerPhaseLabel: "దశ",
  alertsAndNotifications: 'హెచ్చరికలు & నోటిఫికేషన్లు',
  dieselFuelCostPerHour: 'గంటకు ఇంధన ఖర్చు',
  dieselPercentOfRate: 'మీ గంట రేటు యొక్క',
  dieselPriceSaved: 'డీజిల్ ధర సేవ్ అయ్యింది',
  dieselRateSuggestion: 'రేటు సూచన',
  dieselRateIncrease: 'డీజిల్ పెరిగింది — రేటు పెంచడం పరిగణించండి',
  dieselRateDecrease: 'డీజిల్ తగ్గింది — బుకింగ్‌ల కోసం రేటు తగ్గించండి',
  dieselSuggestedRate: 'సూచించిన రేటు',
  dieselHistory: 'ధర చరిత్ర',
  dieselNoHistory: 'డీజిల్ ధర చరిత్ర ఇంకా లేదు',
  dieselColDate: 'తేదీ',
  dieselColPrice: 'ధర/లీటరు',
  dieselColQty: 'పరిమాణం',
  dieselColSource: 'మూలం',
  dieselUploadReceipt: 'రసీదు అప్‌లోడ్',
  dieselExtractSuccess: 'రసీదు నుండి తీసుకున్నారు',
  dieselExtractFailed: 'తీసుకోలేకపోయాం — దయచేసి మాన్యువల్‌గా నమోదు చేయండి',
  applyRateSuggestion: '₹{{rate}}/గంట వర్తింపజేయండి',
  rateSuggestionApplied: 'దర విజయవంతంగా అప్‌డేట్ అయ్యింది',
  marketPosition: 'మార్కెట్ స్థితి',
  marketBelowMarket: 'మార్కెట్ కంటే తక్కువ',
  marketCompetitive: 'పోటీతత్వ',
  marketAboveMarket: 'మార్కెట్ కంటే ఎక్కువ',
  marketNoData: 'మీ ప్రాంతానికి ఇంకా మార్కెట్ డేటా లేదు',
  marketSubmitRate: 'మార్కెట్ రేటు సమర్పించండి',
  marketCity: 'నగరం / ప్రాంతం',
  marketMinRate: 'మీ ప్రాంతంలో కనీస రేటు (₹/గంట)',
  marketMaxRate: 'మీ ప్రాంతంలో గరిష్ట రేటు (₹/గంట)',
  marketRateSubmitted: 'మార్కెట్ రేటు సమర్పించబడింది — ధన్యవాదాలు!',
  marketDataPoints: '{{count}} సమర్పణ(ల) ఆధారంగా',
  marketRange: '{{city}} లో మార్కెట్',
  marketSourceLocal: '{{city}} ప్రాంత రేట్ల ఆధారంగా',
  marketSourcePlatform: 'ప్లాట్‌ఫామ్-వ్యాప్త రేట్ల ఆధారంగా',
  regPremiumOnboarding: 'Premium onboarding',
  regRtoNumber: 'RTO నమోదు నంబర్ *',
  regSelectType: 'రకం ఎంచుకోండి…',
  regSubmitBtn: '✅ నమోదు సమర్పించండి',
  regTagNoRto: 'RTO లేదు',
  regTagRto: 'RTO',
  regYearManufacture: 'తయారీ సంవత్సరం *',
  remoteLockAlert: 'Teltonika GPS device ఈ మెషీన్‌పై స్థాపించిన తర్వాత remote lock enable అవుతుంది. DE support ను సంప్రదించండి.',
  remoteLockMachine: '🔒 రిమోట్ లాక్ మెషీన్',
  replaceFile: 'మార్చు',
  reports: 'నివేదికలు',
  reportText: 'నివేదిక',
  resetMethodEmail: 'ఇమెయిల్ లింక్',
  resetMethodSms: 'SMS OTP',
  resetPasswordFailed: 'పాస్‌వర్డ్ రీసెట్ చేయలేకపోయాము. కొత్త లింక్ అభ్యర్థించండి.',
  resetPasswordIntro: 'కనీసం 8 అక్షరాల బలమైన పాస్‌వర్డ్ ఎంచుకోండి.',
  resetPasswordMinLength: 'పాస్‌వర్డ్ కనీసం 8 అక్షరాలు ఉండాలి.',
  resetPasswordMissingToken: 'రీసెట్ లింక్ లేదు లేదా చెల్లదు. లాగిన్ నుండి Forgot password వాడండి.',
  resetPasswordSubmit: 'పాస్‌వర్డ్ అప్‌డేట్ చేయండి',
  resetPasswordSuccess: 'పాస్‌వర్డ్ అప్‌డేట్ అయింది. లాగిన్‌కు మళ్లిస్తోంది...',
  resetPasswordTitle: 'కొత్త పాస్‌వర్డ్ సెట్ చేయండి',
  resetPasswordUpdating: 'అప్‌డేట్ అవుతోంది...',
  resetText: 'రీసెట్',
  retryDlqItemTitle: 'DLQ అంశం మళ్లీ ప్రయత్నించండి',
  retryFailedForDlq: 'DLQ అంశం కోసం మళ్లీ ప్రయత్నం విఫలమైంది',
  retryReasonAuditPlaceholder: 'మళ్లీ ప్రయత్నం కారణం (ఆడిట్ కోసం)',
  retryText: 'మళ్లీ ప్రయత్నించండి',
  revenue: 'ఆదాయం',
  running: 'నడుస్తోంది',
  satisfiedNo: 'సంతృప్తి లేదు',
  satisfiedYes: 'అవును, సంతృప్తి',
  save: 'సేవ్ చేయండి',
  scanToPay: 'చెల్లించడానికి స్కాన్ చేయండి',
  scheduleColFeedback: 'ఫీడ్‌బ్యాక్',
  scheduleColQty: 'Qty',
  scheduleColTotal: 'మొత్తం',
  scheduleColType: 'రకం',
  securitySignalsTitle: 'భద్రతా సంకేతాలు',
  selectBook: 'ఈ మెషీన్ బుక్ చేయండి →',
  selectCalc: '📋 ఎంచుకోండి & ఖర్చు చూడండి →',
  selectedMachineText: 'ఎంచుకున్న మెషీన్',
  selectFile: 'ఫైల్ ఎంచుకోండి',
  selectMachineFirst: 'ముందు మెషీన్ ఎంచుకోండి',
  selectQty: 'పరిమాణం ఎంచుకోండి',
  selectRole: 'పాత్రను ఎంచుకోండి',
  send: 'పంపండి',
  sendEmail: 'ఇమెయిల్ పంపండి',
  sendWhatsapp: 'WhatsApp లో పంపండి',
  settlements: 'నిష్కర్ష',
  show: 'చూపించు',
  signIn: 'సైన్ ఇన్ చేయండి',
  signingIn: 'లాగిన్ అవుతోంది...',
  signupCompanyName: 'కంపెనీ పేరు',
  signupContactName: 'సంప్రదింపు పేరు',
  signupCreatePassword: 'పాస్‌వర్డ్ సృష్టించండి',
  signupReenterPassword: 'పాస్‌వర్డ్ మళ్లీ నమోదు',
  signupSectionCompany: 'కంపెనీ',
  signupSectionContact: 'మీ వివరాలు',
  signupSectionSecurity: 'భద్రత',
  sinceExcellence: '2011 నుండి · 15 సం. శ్రేష్ఠత',
  sinceLabel: 'నుండి',
  sloBreachRisk: 'SLO BREACH RISK',
  sloHealthy: 'SLO HEALTHY',
  speed: 'వేగం',
  staleText: 'పాతది',
  status: 'స్థితి',
  statusCancelled: 'రద్దు',
  bookingClosed: 'మూసివేయబడింది',
  sectionNew: 'కొత్త',
  sectionAccepted: 'ఆమోదించబడింది',
  sectionActive: 'యాక్టివ్',
  sectionDispatched: 'డిస్పాచ్',
  sectionCompleting: 'పూర్తవుతోంది',
  sectionDisputed: 'వివాదం',
  sectionCompleted: 'పూర్తి',
  sectionClosed: 'మూసివేయబడింది',
  statusCompleted: 'పూర్తి',
  stopped: 'ఆగింది',
  submit: 'సమర్పించండి',
  submitOperatorFeedback: 'ఫీడ్‌బ్యాక్ సమర్పించండి',
  submittedRegistrations: 'సమర్పించిన నమోదులు',
  support: 'మద్దతు',
  supportPolicyBooking: 'వాలెట్-only అడ్వాన్స్. సైట్‌లో నగదు లేదు.',
  supportPolicyCancellation: '1 గంట జరిమానా; మిగిలినది వాలెట్‌కు.',
  supportPolicyContact: 'DE Support మాత్రమే — ప్రత్యక్ష డ్రైవర్ సంపర్కం నిషేధం.',
  supportPolicyGst: 'అన్ని ఇన్వాయిస్‌లపై 18% GST; Reports ట్యాబ్ నుండి డౌన్‌లోడ్.',
  supportPolicyHours: 'సోమ–శని, 9–7 IST',
  tableAtt: 'Att',
  tableChange: 'మార్పు',
  tableDay: 'రోజు',
  tableEnd: 'ముగింపు',
  tableHrs: 'గం',
  tableId: 'ID',
  tableIn: 'In',
  tableLevel: 'స్థాయి',
  tableMonth: 'నెల',
  tableNote: 'నోట్',
  tableOut: 'Out',
  tableStart: 'ప్రారంభం',
  tagline: 'మౌలిక సదుపాయాల స్వర్ణ ప్రమాణం',
  tax: 'పన్ను',
  tdsGstTcs: 'TDS 2% + GST TCS 1%',
  tdsTcs: 'TDS+TCS',
  termCommission: 'Development Express కమీషన్: స్థూల బిల్లింగ్ యొక్క 15%',
  termFuel: 'మెషీన్‌లో ఎప్పుడూ 40%+ ఇంధనం ఉండాలి',
  termGps: 'GPS device (Teltonika) తప్పనిసరి — DE ద్వారా స్థాపించబడుతుంది',
  termGstTcs: 'GST TCS: GST regulations ప్రకారం 1%',
  termNoDirectContact: 'ప్రత్యక్ష గ్రాహకుడు సంప్రదింపు = వెంటనే contract termination',
  termPaymentDays: 'గ్రాహకుడు settlement తర్వాత 3 పని దినాల్లో చెల్లింపు',
  termTds: 'TDS deduction: Income Tax Act ప్రకారం 2%',
  threeWorkingDays: '3 పని దినాలు',
  timeLabel: 'సమయం',
  todayText: 'ఈరోజు',
  topSourceIp: 'టాప్ సోర్స్ IP',
  total: 'మొత్తం',
  totalAdvanceLabel: 'అడ్వాన్స్ చెల్లించబడింది',
  totalBookingsText: 'మొత్తం బుకింగ్‌లు',
  totalMachines: 'మొత్తం మెషీన్‌లు',
  totalSpent: 'మొత్తం ఖర్చు',
  tracking: 'GPS ట్రాకింగ్',
  transactionHistoryTitle: 'లావాదేవీ చరిత్ర',
  transactions: 'లావాదేవీ చరిత్ర',
  trustStatCompliant: 'అనుపాలన',
  trustStatMachines: 'మెషీన్‌లు',
  trustStatRating: 'రేటింగ్',
  txnDescription: 'వివరణ',
  type: 'రకం',
  understood: '✅ అర్థమైంది — వేదికను ఉపయోగిస్తాను',
  understoodAction: 'అర్థమైంది',
  unknownText: 'తెలియదు',
  updateFuel: 'ఇంధనం అప్‌డేట్',
  updateText: 'అప్‌డేట్',
  upiAppsHint: 'PhonePe | GPay | Paytm | BHIM',
  uploadFile: 'అప్‌లోడ్',
  valEmail: 'చెల్లుబాటు అయ్యే ఇమెయిల్ అవసరం',
  valMachineName: 'మెషీన్ పేరు / model అవసరం',
  valMachineType: 'దయచేసి equipment category ఎంచుకోండి',
  valMobility: 'దయచేసి wheeled లేదా crawler equipment రకం ఎంచుకోండి',
  valOwnerName: 'యజమాని పేరు అవసరం',
  valPdiChecks: 'దయచేసి అన్ని required checks confirm చేయండి',
  valPdiRequired: 'PDI confirmation అవసరం',
  valPhone: 'చెల్లుబాటు అయ్యే ఫోన్ నంబర్ అవసరం',
  valRto: 'Wheeled machines కోసం RTO registration number అవసరం',
  valUploadMissing: 'దయచేసి upload చేయండి: {docs}',
  valYear: 'చెల్లుబాటు అయ్యే year (YYYY) అవసరం',
  viewMachines: '→ మెషీన్‌లు చూడండి',
  wallet: 'వాలెట్',
  walletBalance: 'వాలెట్ బ్యాలెన్స్',
  walletCredit: 'వాలెట్ క్రెడిట్',
  walletDebit: 'వాలెట్ డెబిట్',
  walletDeduct: 'అడ్వాన్స్ వాలెట్ నుండి తీసివేయబడుతుంది · నగదు లేదు · GST స్వయంచాలకంగా రూపొందుతుంది',
  walletInsufficient: '❌ సరిపోదు',
  walletLowRecharge: 'వాలెట్ బ్యాలెన్స్ తక్కువ — తదుపరి బుకింగ్ ముందు రీఛార్జ్ చేయండి',
  walletOnly: 'వాలెట్ మాత్రమే · నగదు అంగీకరించబడదు',
  walletOnlyPolicyDesc: 'అన్ని లావాదేవీలు వాలెట్ ద్వారా మాత్రమే. నగదు అంగీకరించబడదు.',
  walletOnlyPolicyTitle: 'వాలెట్-మాత్రమే విధానం',
  walletRechargeTitle: 'వాలెట్ రీఛార్జ్',
  walletSufficient: '✅ కొనసాగండి',
  weeks: 'వారాలు',
  whatsapp: 'WhatsApp',
  wksUnit: 'వారాలు',
  year: 'సంవత్సరం',
  yearsExperience: '{n} సంవత్సరాలు',
  yourMessage: 'మీ ప్రశ్న లేదా సమస్య రాయండి...',
  // --- Recent feature strings ---
  retryLabel: 'మళ్లీ ప్రయత్నించండి',
  payrollPreview: 'జీతం ప్రివ్యూ',
  payrollRun: 'జీతం రన్ చేయండి',
  payrollAlreadyRun: 'ఈ నెలకు జీతం ఇప్పటికే రన్ అయింది',
  payrollGross: 'మొత్తం చెల్లించవలసిన',
  payrollNet: 'నికర చెల్లించవలసిన',
  payrollAdvanceDeducted: 'అడ్వాన్స్ తగ్గింపు',
  payrollRunSuccess: 'జీతం విజయవంతంగా రన్ అయింది',
  payrollNoAmount: 'ఈ నెలకు చెల్లించదగిన మొత్తం లేదు',
  payrollMonth: 'జీతం నెల',
  exportPayrollCsv: 'జీతం CSV ఎగుమతి',
  payrollExportMonth: 'జీతం ఎగుమతి నెల',
  payrollDailyRate: 'రోజువారీ రేటు',
  payrollHistory: 'జీతం చరిత్ర',
  payrollNoHistory: 'ఇంకా జీతం రన్ కాలేదు',
  payrollColMonth: 'నెల',
  payrollColGross: 'మొత్తం',
  payrollColDeduction: 'అడ్వాన్స్ తగ్గింపు',
  payrollColNet: 'నికర జీతం',
  payrollColDate: 'తేదీ',
  downloadPayslip: 'పే స్లిప్ డౌన్‌లోడ్',
  payslipTitle: 'నెలవారీ పే స్లిప్',
  payslipEarnings: 'ఆదాయం',
  payslipDeductions: 'తగ్గింపులు',
  payslipDaysWorked: 'పని రోజులు',
  payslipGeneratedBy: 'Development Express ద్వారా రూపొందించబడింది',
  operatorPayrollTitle: 'నా జీతం',
  payrollMonthlySalary: 'నెలవారీ జీతం',
  payrollCurrentMonth: 'ప్రస్తుత నెల',
  payrollPreviousMonth: 'మునుపటి నెల',
  ownerAttendanceTitle: 'హాజరు',
  ownerAttendanceEdit: 'సవరించు',
  ownerAttendanceSave: 'సేవ్',
  ownerAttendanceNoRecords: 'ఈ నెలకు హాజరు రికార్డులు లేవు',
  ownerAttendanceOverrideSuccess: 'హాజరు నవీకరించబడింది',
  ownerSalaryUpdated: 'జీతం విజయవంతంగా నవీకరించబడింది',
  ownerSalaryEditBtn: 'జీతం సవరించు',
  ownerSalaryNotSet: 'జీతం సెట్ చేయలేదు — పేరోల్ కోసం జీతం సెట్ చేయండి',
  duration: "వ్యవధి",
  durationLabel: 'వ్యవధి',
  plQuotaLabel: 'పీఎల్ కోటా',
  plUsed: 'వాడిన',
  plAllowed: 'అనుమతి',
  plRemaining: 'మిగిలిన',
  plQuotaUpdated: 'PL కోటా నవీకరించబడింది',
  plQuotaExhausted: 'PL కోటా అయిపోయింది — చెల్లని సెలవుగా గుర్తించబడింది',
  plRemainingLabel: 'మిగిలిన PL',
  noAttendanceRecords: 'ఇంకా హాజరు రికార్డ్‌లు లేవు',
  noFuelLogs: 'ఇంకా ఇంధన లాగ్‌లు లేవు',
  noIssuesYet: 'ఇంకా సమస్యలు నమోదు కాలేదు',
  failedToLoad: 'డేటా లోడ్ చేయడం విఫలమైంది',
  failedToLoadReport: 'నివేదిక లోడ్ చేయడం విఫలమైంది',
  failedToLoadIssues: 'సమస్యలు లోడ్ చేయడం విఫలమైంది',
  failedToLoadAlerts: 'అలర్ట్‌లు లోడ్ చేయడం విఫలమైంది',
  noRecordsMonth: 'ఈ నెలకు రికార్డ్‌లు లేవు',
  underReview: 'సమీక్షలో ఉంది',
  issueResolved: 'పరిష్కరించబడింది',
  presentDaysLabel: 'హాజరు రోజులు',
  halfDaysLabel: 'సగం రోజులు',
  absentDaysLabel: 'గైర్హాజరు రోజులు',
  totalHmrLabel: 'మొత్తం HMR',
  noActiveBookingIdle: 'సక్రియ బుకింగ్ లేదు — మెషీన్ నిష్క్రియంగా ఉంది',
  siteLocationNotCaptured: 'సైట్ స్థానం నమోదు కాలేదు',
  siteLocationNotAvailable: 'సైట్ స్థానం అందుబాటులో లేదు',
  bookingRefLabel: 'బుకింగ్ Ref',
  alertPendingBookings: 'పెండింగ్ బుకింగ్‌లు',
  alertPendingPayouts: 'పెండింగ్ చెల్లింపులు',
  alertLowFuel: 'తక్కువ ఇంధనం',
  alertOpenIssues: 'పరిష్కారం కాని సమస్యలు',
  noMachineRunning: 'ప్రస్తుతం ఏ మెషీన్ అమల్లో లేదు',
  trackingEmptyHint: 'మెషీన్ పంపిన తర్వాత మీ సక్రియ బుకింగ్ ఇక్కడ కనిపిస్తుంది.',
  trackingUpdatedEvery5s: 'ప్రతి 5 సెకన్లకు నవీకరించబడుతుంది',
  fuelLastOperatorUpdate: '(ఆపరేటర్ చివరి నవీకరణ)',
  alertExtensionPending: 'బుకింగ్ ఎక్స్టెన్షన్ పెండింగ్',
  alertConfirmCompletion: 'దయచేసి పని పూర్తి నిర్ధారించండి',
  alertWalletCredited: 'వాలెట్‌కు జోడించబడింది',
  alertFeedbackRequest: 'పని పూర్తి — మీ అభిప్రాయం పంచుకోండి',
  noLogsYet: 'ఇంకా కార్యకలాపం నమోదు కాలేదు',
  todayActivityLog: 'నేటి కార్యకలాప లాగ్',
  machineLogSubtitle: 'ఇంధనం, హాజరు, సమస్యలు — స్థానిక సెషన్ లాగ్',
  timerPaused: 'Timer పాజ్ చేయబడింది',
  liveBookingTitle: 'లైవ్ బుకింగ్',
  machineLogTimerHint: 'Timer Admin ప్రారంభిస్తాడు. క్రింద మీ అసలు పని సమయాన్ని నమోదు చేయండి — పూర్తయిన తర్వాత Mark Work Complete క్లిక్ చేయండి.',
  resumeTimer: 'Resume Timer',
  pauseTimer: 'Pause Timer',
  attendanceLogNote: 'హాజరు',
  ownerAlertBookingPending: 'కొత్త బుకింగ్ మీ ఆమోదం కోసం పెండింగ్ —',
  ownerAlertBookingHours: 'గంటలు',
  ownerAlertPayoutPending: '₹{{amount}} చెల్లింపు బదిలీ కోసం పెండింగ్',
  ownerAlertFuelLow: 'ఇంధనం తక్కువ',
  ownerAlertFuelRemaining: 'మిగిలింది',
  ownerAlertIssue: 'సమస్య నమోదు',
  iotGpsDevicesActive: 'GPS పరికరాలు సక్రియం',
  iotDashcamsOnline: 'డాష్‌క్యామ్‌లు ఆన్‌లైన్',
  iotFuelSensorsActive: 'ఇంధన సెన్సార్లు సక్రియం',
  iotMachinesLocked: 'మెషీన్లు లాక్',
  iotDeviceStatus: 'IoT పరికర స్థితి',
  iotColMachine: 'మెషీన్',
  iotColGps: 'GPS',
  iotColLocation: 'స్థానం',
  iotColFuel: 'ఇంధన %',
  iotColDashcam: 'డాష్‌క్యామ్',
  iotColIgnition: 'ఇగ్నిషన్',
  iotColAction: 'చర్య',
  iotStatusOnline: 'ఆన్‌లైన్',
  iotStatusNotConnected: 'కనెక్ట్ కాలేదు',
  iotStatusLive: 'లైవ్',
  iotStatusOn: 'ON',
  iotStatusOff: 'OFF',
  iotLockBtn: 'లాక్',
  iotNotConnectedBanner: 'IoT హార్డ్‌వేర్ ఇంకా ఇన్‌స్టాల్ కాలేదు. Teltonika పరికరం ఇన్‌స్టాలేషన్ తర్వాత GPS, డాష్‌క్యామ్ మరియు రిమోట్ లాక్ సౌకర్యాలు అందుబాటులో ఉంటాయి.',
  fuelUpdateTitle: 'ఇంధన అప్డేట్',
  fuelSensorAccuracyNote: 'ఆపరేటర్ నమోదు చేసిన ఇంధన స్థాయి · మాన్యువల్ ఎంట్రీ',
  bookingsTab: 'బుకింగ్‌లు',
  unknownLabel: 'తెలియని',
  naLabel: 'N/A',
  baseLabel: 'ఆధారం',
  qtyLabel: 'పరిమాణం',
  actualHrsLabel: 'నిజమైన గంటలు',
  auditStatTotal: 'మొత్తం',
  auditStatSecurity: 'భద్రత',
  auditStatActors: 'చర్యదారులు',
  auditStatAdmin: 'Admin',
  auditStatNonAdmin: 'Non-Admin',
  kycDocLicense: 'లైసెన్స్',
  kycDocAadhaarFront: 'Aadhaar ముందు',
  kycDocAadhaarBack: 'Aadhaar వెనుక',
  kycDocPoliceVerification: 'పోలీస్ ధృవీకరణ',
  kycVerification: 'KYC ధృవీకరణ',
  kycNotSubmitted: 'KYC సమర్పించలేదు',
  kycUnderReview: 'KYC సమీక్షలో ఉంది',
  kycVerified: 'KYC ధృవీకరించబడింది',
  kycRejected: 'KYC తిరస్కరించబడింది',
  kycAadhaarFront: 'Aadhaar ముందు',
  kycAadhaarBack: 'Aadhaar వెనుక',
  kycSelfie: 'సెల్ఫీ',
  kycSubmitBtn: 'KYC పత్రాలు సమర్పించండి',
  kycSubmitSuccess: 'పత్రాలు సమర్పించబడింది — సమీక్షలో',
  kycResubmit: 'మళ్లీ పత్రాలు సమర్పించండి',
  adminKycTitle: 'క్లయింట్ KYC సమీక్షలు',
  adminKycAllFilter: 'అన్నీ',
  adminKycNoSubmissions: 'ఇంకా KYC సమర్పణలు లేవు',
  adminOwnerKycTitle: 'యజమాని KYC సమీక్ష',
  adminOwnerKycNoSubmissions: 'ఇంకా యజమాని KYC సమర్పణలు లేవు',
  adminOperatorKycTitle: 'ఆపరేటర్ KYC సమీక్ష',
  adminOperatorKycNoSubmissions: 'ఇంకా ఆపరేటర్ KYC సమర్పణలు లేవు',
  kycRejectedWarning: 'మీ KYC తిరస్కరించబడింది. దయచేసి పత్రాలను మళ్లీ సమర్పించండి.',
  kycNotSubmittedHint: 'విశ్వసనీయ అనుభవం కోసం KYC పూర్తి చేయండి.',
  kycPendingHint: 'మీ KYC సమీక్షలో ఉంది.',
  kycGoToTab: 'KYC కు వెళ్లండి',
  adminKycApproveBtn: 'ఆమోదించు',
  adminKycRejectBtn: 'తిరస్కరించు',
  adminKycViewDocs: 'పత్రాలు చూడండి',
  adminKycRejectReason: 'తిరస్కరణ కారణం',
  adminKycRereviewBtn: 'మళ్లీ సమీక్ష',
  kycPan: 'PAN కార్డ్',
  kycOwnerSubmitSuccess: 'పత్రాలు సమర్పించబడ్డాయి — మీ KYC సమీక్షలో ఉంది',
  kycLicense: 'డ్రైవింగ్ లైసెన్స్',
  kycPoliceVerification: 'పోలీస్ ధృవీకరణ',
  kycOperatorSubmitSuccess: 'పత్రాలు సమర్పించబడ్డాయి — మీ KYC సమీక్షలో ఉంది',
  operatorKycRejectedAssign: 'ఈ ఆపరేటర్ KYC తిరస్కరించబడింది — తిరిగి ఆమోదించబడేవరకు వారిని నియమించలేము.',
  operatorsColOperator: 'ఆపరేటర్',
  operatorsColEmail: 'ఇమెయిల్',
  operatorsColPhone: 'ఫోన్',
  operatorsColDocuments: 'పత్రాలు',
  operatorsColStatus: 'స్థితి',
  operatorsDocumentsBtn: 'పత్రాలు ({{count}})',
  operatorsNoResults: 'ఆపరేటర్లు కనిపించలేదు',
  operatorsAllTitle: 'అన్ని ఆపరేటర్లు ({{count}})',
  operatorsKycDialogDesc: 'KYC పత్రాలు',
  bookingsCountLabel: '{{count}} బుకింగ్‌లు',
  complianceDates: 'అనుపాలన తేదీలు',
  complianceInsurance: 'బీమా',
  complianceRcBook: 'RC బుక్',
  compliancePuc: 'PUC',
  complianceNotSet: 'సెట్ చేయలేదు',
  complianceExpired: 'గడువు ముగిసింది',
  complianceExpiringSoon: 'త్వరలో గడువు ముగుస్తుంది',
  complianceExpiringCritical: '7 రోజుల్లో గడువు',
  complianceValid: 'చెల్లుబాటు',
  complianceUpdateBtn: 'అనుపాలన తేదీలు అప్‌డేట్ చేయండి',
  complianceSaveBtn: 'సేవ్',
  complianceAlertsTitle: 'అనుపాలన అలర్ట్‌లు',
  complianceAllCompliant: 'అన్ని మెషీన్‌లు అనుపాలనలో ఉన్నాయి ✅',
  complianceColMachine: 'మెషీన్',
  complianceColOwner: 'యజమాని',
  complianceColInsurance: 'బీమా',
  complianceColRcBook: 'RC బుక్',
  complianceColPuc: 'PUC',
  complianceNa: 'N/A',
  complianceStartDate: 'ప్రారంభ తేదీ',
  complianceEndDate: 'ముగింపు తేదీ',
  complianceExtractBtn: 'తేదీలను స్వయంచాలకంగా నింపడానికి పత్రాన్ని అప్‌లోడ్ చేయండి',
  complianceExtractSuccess: 'తేదీలు వెలికి తీయబడ్డాయి — సేవ్ చేయడానికి ముందు ధృవీకరించండి',
  complianceExtractError: 'తేదీలు వెలికి తీయలేకపోయాము — దయచేసి చేతితో నమోదు చేయండి',
  complianceExtracting: 'పత్రం చదువుతున్నారు...',
  serviceHistory: 'సేవా చరిత్ర',
  serviceLastService: 'చివరి సేవ',
  serviceNoRecords: 'ఇంకా సేవా రికార్డులు లేవు',
  serviceNextDue: 'తదుపరి సేవ గడువు',
  serviceNextHmr: 'తదుపరి సేవ వద్ద',
  serviceAddLog: 'సేవా లాగ్ జోడించండి',
  serviceDate: 'సేవా తేదీ',
  serviceType: 'సేవా రకం',
  serviceHmr: 'సేవ వద్ద HMR',
  serviceNextDate: 'తదుపరి సేవ తేదీ',
  serviceWorkDone: 'చేసిన పని',
  serviceNotes: 'గమనికలు',
  serviceTypeRoutine: 'సాధారణ',
  serviceTypeMajor: 'ప్రధాన',
  serviceTypeBreakdown: 'బిగుసు',
  serviceTypePdi: 'PDI',
  serviceTypeOther: 'ఇతర',
  serviceOverdue: 'గడువు మీరింది',
  serviceDueSoon: 'త్వరలో గడువు',
  fleetAnalytics: 'ఫ్లీట్ ఎనలిటిక్స్',
  analyticsRevenue: 'మొత్తం ఆదాయం',
  analyticsBookings: 'మొత్తం బుకింగ్‌లు',
  analyticsHours: 'మొత్తం గంటలు',
  analyticsActiveMachines: 'సక్రియ మెషీన్‌లు',
  analyticsMonthlyTrend: 'నెలవారీ ఆదాయ ట్రెండ్',
  analyticsMachineTable: 'మెషీన్ వారీగా ఆదాయం',
  analyticsNoData: 'ఈ కాలంలో పూర్తి అయిన బుకింగ్‌లు లేవు',
  analyticsLastBooking: 'చివరి బుకింగ్',
  analytics3Months: '3 నెలలు',
  analytics6Months: '6 నెలలు',
  analytics12Months: '12 నెలలు',
  adminAnalytics: 'ఎనలిటిక్స్',
  adminFleetTitle: 'ఫ్లీట్ ఎనలిటిక్స్',
  adminFleetPlatformRevenue: 'ప్లాట్‌ఫారమ్ ఆదాయం',
  adminFleetActiveOwners: 'సక్రియ యజమానులు',
  adminFleetOwnerCol: 'యజమాని',
  adminFleetMonthlyTrend: 'నెలవారీ ఆదాయ ట్రెండ్',
  adminFleetMachineTable: 'మెషీన్ వారీగా ఆదాయం',
  adminFleetNoData: 'ఈ కాలంలో పూర్తి అయిన బుకింగ్‌లు లేవు',
  adminFinancialIntelligence: 'మెషీన్ ఆర్థిక సమాచారం',
  adminTotalInvested: 'మొత్తం పెట్టుబడి',
  adminTotalEarned: 'మొత్తం ఆదాయం',
  adminAvgRecovery: 'సగటు రికవరీ',
  adminBreakEvenRate: 'బ్రేక్-ఈవన్ రేటు',
  adminProfitMargin: 'లాభ మార్జిన్',
  adminNoFinancialData: 'ఇంకా ఆర్థిక డేటా ఉన్న మెషీన్లు లేవు',
  adminMachineDetail: 'మెషీన్ వివరాలు',
  adminCallOwner: 'యజమానికి కాల్',
  adminWhatsappOwner: 'WhatsApp యజమాని',
  adminMarketRates: 'మార్కెట్ రేట్ సమర్పణలు',
  adminMarketRateDelete: 'తొలగించు',
  adminMarketRateDeleteConfirm: 'ఈ మార్కెట్ రేట్ సమర్పణను తొలగించాలా?',
  adminMarketRateDeleted: 'మార్కెట్ రేట్ తొలగించబడింది',
  adminMarketRateNoData: 'ఇంకా మార్కెట్ రేట్ సమర్పణలు లేవు',
  marketRateApprove: 'ఆమోదించు',
  marketRateReject: 'తిరస్కరించు',
  marketRateApproved: 'ఆమోదించబడింది',
  marketRateRejected: 'తిరస్కరించబడింది',
  marketRatePending: 'పెండింగ్',
  marketRateReviewed: 'మార్కెట్ రేట్ సమీక్షించబడింది',
  marketRatePendingReview: 'మీ రేటు సమర్పించబడింది మరియు అడ్మిన్ సమీక్షలో పెండింగ్‌లో ఉంది.',
  marketRateEditApprove: 'సవరించి ఆమోదించు',
  marketRateEditMin: 'సరిదిద్దిన కనిష్ట రేటు (₹/గం)',
  marketRateEditMax: 'సరిదిద్దిన గరిష్ట రేటు (₹/గం)',
  adminPayrollOverview: 'జీతం అవలోకనం',
  adminPayrollTotalOperators: 'మొత్తం ఆపరేటర్లు',
  adminPayrollTotalGross: 'మొత్తం చెల్లించాల్సిన మొత్తం',
  adminPayrollTotalNet: 'మొత్తం నికర చెల్లింపు',
  adminPayrollNoData: 'ఈ నెలకు జీతం డేటా లేదు',
  subTabSchedule: 'షెడ్యూల్',
  subTabHistory: 'చరిత్ర',
  subTabAnalytics: 'అనలిటిక్స్',
  clientAnalyticsTitle: 'బుకింగ్ అనలిటిక్స్',
  clientAnalyticsSpend: 'మొత్తం ఖర్చు',
  clientAnalyticsHours: 'మొత్తం గంటలు',
  clientAnalyticsBookings: 'పూర్తి అయిన బుకింగ్‌లు',
  clientAnalyticsMachines: 'ఉపయోగించిన మెషీన్‌లు',
  clientAnalyticsAvgSpend: 'బుకింగ్‌కు సగటు',
  clientAnalyticsMonthlyTrend: 'నెలవారీ ఖర్చు ట్రెండ్',
  clientAnalyticsTopMachines: 'టాప్ మెషీన్‌లు',
  clientAnalyticsNoData: 'ఈ కాలంలో పూర్తి అయిన బుకింగ్‌లు లేవు',
  operatorAnalyticsTitle: 'పని అనలిటిక్స్',
  operatorAnalyticsPresentDays: 'హాజరు రోజులు',
  operatorAnalyticsHalfDays: 'సగం రోజు',
  operatorAnalyticsHmr: 'మొత్తం HMR',
  operatorAnalyticsJobs: 'పూర్తి అయిన పనులు',
  operatorAnalyticsIssues: 'నివేదించిన సమస్యలు',
  operatorAnalyticsAvgHmr: 'సగటు HMR/రోజు',
  operatorAnalyticsMonthlyTrend: 'నెలవారీ పని ట్రెండ్',
  operatorAnalyticsIssueBreakdown: 'రకం వారీగా సమస్యలు',
  operatorAnalyticsRecentJobs: 'ఇటీవలి పనులు',
  operatorAnalyticsNoData: 'ఈ కాలంలో పని రికార్డులు లేవు',
  adminServiceAlertsTitle: 'సేవా అలర్ట్‌లు',
  adminServiceAllOk: 'అన్ని మెషీన్‌ల సేవా రికార్డులు అప్‌డేట్‌గా ఉన్నాయి ✅',
  adminServiceNoRecord: 'రికార్డులు లేవు',
  adminServiceColLastService: 'చివరి సేవ',
  adminServiceColNextDue: 'తదుపరి గడువు',
  adminServiceColServiceStatus: 'సేవా స్థితి',
  adminMachinesColMinHrs: 'కనీస గంటలు',
  adminMachinesColRateDay: 'రేటు/రోజు',
  adminClientName: 'గ్రాహక పేరు',
  adminOwnerName: 'యజమాని పేరు',
  adminPayoutWallet: 'చెల్లింపు వాలెట్',
  adminFooterMachines: 'యంత్రాలు',
  adminFooterClients: 'క్లయింట్లు',
  adminFooterOwners: 'యజమానులు',
  auditSeverityCritical: 'క్లిష్టమైన',
  auditSeverityHigh: 'అధిక',
  auditSeverityMedium: 'మధ్యస్థ',
  auditSeverityNormal: 'సాధారణ',
  auditCopyEvent: 'ఈవెంట్ కాపీ చేయండి',
  auditViewDetails: 'వివరాలు చూడండి',
  auditHideDetails: 'వివరాలు దాచండి',
  auditCopyJson: 'JSON కాపీ చేయండి',
  auditNoLogs: 'ఆడిట్ లాగ్‌లు లేవు',
  auditIntroBanner: 'లాగిన్, అడ్మిన్ చర్యలు మరియు భద్రతా సంఘటనలు. ఫిల్టర్లు లోడ్ చేసిన ఫలితాలపై వర్తిస్తాయి; పాత వరుసల కోసం మరిన్ని లోడ్ చేయండి.',
  auditLoaded: 'లోడ్ చేయబడినవి',
  auditMoreAvailable: 'మరిన్ని అందుబాటులో',
  auditEndOfList: 'జాబితా ముగింపు',
  auditFilterActive: 'ఫిల్టర్ సక్రియం',
  auditFiltersActive: 'ఫిల్టర్లు సక్రియం',
  auditSeverityBreakdown: 'తీవ్రత విభజన (ప్రస్తుత జాబితా)',
  auditPressSlash: 'చర్య ఫిల్టర్‌పై ఫోకస్ చేయడానికి / నొక్కండి',
  auditFilters: 'ఫిల్టర్లు',
  auditFilterActionPlaceholder: 'Filter action (e.g. dlq_retry)',
  auditFilterActorPlaceholder: 'Filter actorId',
  auditAllRoles: 'అన్ని పాత్రలు',
  auditFilterEntityPlaceholder: 'Entity type (e.g. dead_letter_queue)',
  auditFilterMetaPlaceholder: 'మెటాడేటా JSON శోధించండి',
  auditFilterFromPlaceholder: 'ప్రారంభ తేదీ మరియు సమయం',
  auditFilterToPlaceholder: 'ముగింపు తేదీ మరియు సమయం',
  audit24h: '24h',
  audit7d: '7d',
  auditTimezonePrefix: 'సమయ మండలి:',
  auditTimezoneSuffix: '(స్థానిక)',
  auditHideCsvOptions: 'CSV నిలువు వరుస ఎంపికలను దాచండి',
  auditShowCsvOptions: 'CSV నిలువు వరుస ఎంపికలను చూపండి',
  auditCsvColCreatedAt: 'సృష్టి సమయం',
  auditCsvColAction: 'చర్య',
  auditCsvColActorId: 'Actor ID',
  auditCsvColActorRole: 'Actor Role',
  auditCsvColEntityType: 'Entity Type',
  auditCsvColEntityId: 'Entity ID',
  auditCsvColMetadata: 'మెటాడేటా',
  auditFooterLoaded: 'లోడ్ చేయబడినవి',
  auditFooterLogs: 'ఆడిట్ లాగ్‌లు',
  auditFooterMoreAvailable: '(మరిన్ని అందుబాటులో)',
  auditFooterAllLoaded: '(అన్నీ లోడ్ చేయబడినవి)',
  auditActor: 'అభినేత',
  auditEntity: 'ఎంటిటీ',
  auditEventLog: 'ఈవెంట్ లాగ్',
  notificationCenter: 'నోటిఫికేషన్లు',
  notifChannelAll: 'అన్నీ',
  notifChannelWhatsapp: 'WhatsApp',
  notifChannelEmail: 'ఈమెయిల్',
  notifChannelPush: 'పుష్',
  notifChannelSms: 'SMS',
  notifStatusSent: 'పంపబడింది',
  notifStatusFailed: 'విఫలమైంది',
  notifStatusPending: 'బాకీ',
  notifEmpty: 'ఇంకా నోటిఫికేషన్లు లేవు',
  notifLoadMore: 'మరిన్ని లోడ్ చేయండి',
  adminNotifLog: 'నోటిఫికేషన్ లాగ్',
  adminNotifColUser: 'వినియోగదారు',
  adminNotifColRole: 'పాత్ర',
  adminNotifNoData: 'ఇంకా నోటిఫికేషన్లు లాగ్ కాలేదు',
  etaOwnerApproval: 'యజమాని అనుమతి కోసం వేచి ఉంది',
  etaWorkInProgress: 'అంచనా పూర్తి',
  etaPaymentDeadline: 'చెల్లింపు నిర్ధారణ గడువు',
  etaWorkCompleted: 'పని పూర్తయింది',
  etaDisputeReview: 'DE బృందం వివాదాన్ని సమీక్షిస్తోంది',
  etaMinutesRemaining: '{n} నిమిషాలు మిగిలి ఉన్నాయి',
  etaHoursRemaining: '{n} గంటలు మిగిలి ఉన్నాయి',
  txRecharge: 'వాలెట్ రీఛార్జ్',
  txBookingAdvance: 'బుకింగ్ అడ్వాన్స్',
  txBookingPayment: 'బుకింగ్ చెల్లింపు',
  txSettlement: 'సెటిల్‌మెంట్',
  txRefund: 'రీఫండ్',
  txPenalty: 'జరిమానా',
  txCommission: 'కమిషన్',
  tacTitle: "నిబంధనలు & షరతులు",
  tacPrivacy: "గోప్యతా విధానం",
  tacRefund: "రీఫండ్ విధానం",
  tacCancellation: "రద్దు విధానం",
  tacServiceDelivery: "సేవా డెలివరీ విధానం",
  tacIntro: "బుకింగ్‌కు ముందు మా విధానాలను చూడండి",
  tacBannerTitle: "నిబంధనల అప్‌డేట్ అందుబాటులో ఉంది",
  tacBannerOpen: "నిబంధనలు తెరవండి",
  tacBannerAgree: "నేను చదివి అంగీకరిస్తున్నాను",
  tacBannerLater: "తర్వాత",
  clientPoliciesTitle: "క్లయింట్ విధానాలు",
  machineGroupAvailable: "అందుబాటులో",
  machineGroupBusy: "బిజీ",
  dewateringReferral: "డీవాటరింగ్ (పంప్) సేవ కావాలా? MachineOS త్వరలో పంప్ కాంట్రాక్టర్ సేవలు జోడిస్తుంది. రెఫరల్స్ కోసం సపోర్ట్‌ను సంప్రదించండి.",
  noActiveWork: "ఈ నెలలో యాక్టివ్ పని లేదు",
  accountTab: "ఖాతా",
  recentActivity: "ఇటీవలి కార్యకలాపం",
  goodMorning: "శుభోదయం",
  goodAfternoon: "శుభ మధ్యాహ్నం",
  goodEvening: "శుభ సాయంత్రం",
  thisMonthEarned: 'This month earned',
  standardBookings: 'Standard bookings',
  activeContracts: 'Active contracts',
  contractsOngoing: 'Contracts ongoing',
  noActiveContracts: 'None this period',
  quotationsPending: 'Quotations awaiting reply',
  allUpToDate: 'All bookings up to date',
  noBookingsInPeriod: 'No bookings in this period',
  contractBookings: 'Contract bookings',
  noContractsInPeriod: 'No contracts in this period',
  mobilizationReleased: 'Mobilization released',
  pendingRelease: 'Pending release',
  raBills: 'RA-bills',
  disputed: 'Disputed',
  all: 'All',
  completed: 'Completed',
};
